<template>
  <WdsModal
    :show="true"
    :title="$t('Review and Approve Classification')"
    lg
    data-test="modal-confirm-classification"
    @cancel="$emit('close')"
  >
    <WdsStack direction-column gap-md>
      <div
        class="tw-w-full tw-border tw-border-gray-300 tw-rounded-lg tw-overflow-hidden tw-h-[60vh] tw-max-h-[60vh]"
      >
        <embed
          :src="pdfUrl"
          width="100%"
          height="100%"
          type="application/pdf"
          class="tw-w-full tw-h-full"
        />
      </div>
    </WdsStack>

    <template #footer>
      <form :action="confirmUrl" method="POST" class="tw-w-full" @submit="handleSubmit">
        <WdsStack align-center justify-space-between class="tw-w-full">
          <WdsStack align-center gap-sm data-test="checkbox-confirm-acceptance">
            <WdsCheckbox
              id="confirm-acceptance"
              v-model:checked="confirmed"
              name="confirm_acceptance"
              value="1"
              required
            >
              {{ $t('I have reviewed and approve this classification') }}
            </WdsCheckbox>
          </WdsStack>

          <WdsStack direction-row gap-sm>
            <WdsButton @click="$emit('close')">
              {{ $t('Cancel') }}
            </WdsButton>
            <WdsButton
              type="submit"
              primary
              :disabled="!confirmed"
              :loading="submitting"
              data-test="button-approve-classification"
            >
              {{ $t('Approve Classification') }}
            </WdsButton>
          </WdsStack>
        </WdsStack>

        <input type="hidden" name="_token" :value="csrfToken" />
      </form>
    </template>
  </WdsModal>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'
import { WdsButton, WdsCheckbox, WdsModal, WdsStack } from '@worksome/wds-components'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

interface Props {
  classification: any
  hireNumber: string
  csrfToken: string
}

const props = defineProps<Props>()

defineEmits<{
  close: []
}>()

const confirmed = ref(false)
const submitting = ref(false)

const pdfUrl = computed(() => `/sds/${props.classification.id}/pdf`)
const confirmUrl = computed(() => `/hires/${props.hireNumber}/confirm-sds`)

const handleSubmit = (event: Event) => {
  if (!confirmed.value) {
    event.preventDefault()
    return
  }
  submitting.value = true
  // Let form submit naturally - it will redirect/reload the page
}
</script>
